import ConfirmedOfferPage from "./ConfirmedOfferPage";

export default ConfirmedOfferPage;